import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const getAuthHeaders = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const token = userDetails?.idToken || "";
  return { Authorization: `Bearer ${token}` };
};

export const getCommissionApi = () => {
  return axios.get(`${API_BASE_URL}/api/admin/commission`, {
    headers: getAuthHeaders(),
  });
};

export const updateCommissionApi = (commissionPercentage) => {
  return axios.put(
    `${API_BASE_URL}/api/admin/commission`,
    { commissionPercentage },
    { headers: getAuthHeaders() },
  );
};

export const getWithdrawalRequestsApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/admin/withdrawals`, {
    params,
    headers: getAuthHeaders(),
  });
};

export const processWithdrawalApi = (id, payload) => {
  return axios.patch(`${API_BASE_URL}/api/admin/withdrawals/${id}`, payload, {
    headers: getAuthHeaders(),
  });
};

export const getAdminEarningStatsApi = () => {
  return axios.get(`${API_BASE_URL}/api/admin/earnings/stats`, {
    headers: getAuthHeaders(),
  });
};

export const getConsultantEarningsApi = (consultantId) => {
  return axios.get(
    `${API_BASE_URL}/api/admin/earnings/consultant/${consultantId}`,
    { headers: getAuthHeaders() },
  );
};

export const getAdminSessionsApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/admin/sessions`, {
    params,
    headers: getAuthHeaders(),
  });
};

export const getAdminRevenueApi = (params = {}) => {
  return axios.get(`${API_BASE_URL}/api/admin/revenue`, {
    params,
    headers: getAuthHeaders(),
  });
};

export const listCommissionRatesApi = () => {
  return axios.get(`${API_BASE_URL}/api/admin/commission/rates`, {
    headers: getAuthHeaders(),
  });
};

export const addCommissionRateApi = (payload) => {
  return axios.post(`${API_BASE_URL}/api/admin/commission/rates`, payload, {
    headers: getAuthHeaders(),
  });
};

export const activateCommissionRateApi = (id) => {
  return axios.patch(
    `${API_BASE_URL}/api/admin/commission/rates/${id}/activate`,
    {},
    { headers: getAuthHeaders() },
  );
};

export const deactivateCommissionRateApi = (id) => {
  return axios.patch(
    `${API_BASE_URL}/api/admin/commission/rates/${id}/deactivate`,
    {},
    { headers: getAuthHeaders() },
  );
};

export const deleteCommissionRateApi = (id) => {
  return axios.delete(`${API_BASE_URL}/api/admin/commission/rates/${id}`, {
    headers: getAuthHeaders(),
  });
};
